import API from "@/lib/api.js";
import httpfun from "@/lib/request.js";
import tool from "@/lib/tool.js";
//import { parseGeoJSON } from "echarts/lib/export";
let $http = httpfun.http;
let $httpfile = httpfun.httpfile;
let $httptxt=httpfun.httptxt;
let $httpform=httpfun.httpform;
let $api = API.API //,domain = API.WebServer
let post = {
	DownCargoPic:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DownCargoPic, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	delfeelisttemp:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.delfeelisttemp, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//保存账单模板
	SaveFeelistTemp:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveFeelistTemp, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	
	//保存设备参数方案
	SaveParamtodevice:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveParamtodevice, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	
	//商品上架/下架
	setcargoisshelves:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.setcargoisshelves, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	UpdateTempnum:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateTempnum, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	UploadCargoPriceLabel:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UploadCargoPriceLabel, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	AuditdeviceAccount:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.AuditdeviceAccount, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	UpdateWeightSingle:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateWeightSingle, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//通用删除方法，处理无复杂业务逻辑的表
	DelTabledata:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelTabledata, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//删除询价单
	Delxj:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Delxj, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//删除报价表
	Delbj:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Delbj, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//删除货架表
	Deldd:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Deldd, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//删除应收账单
	Delws:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Delws, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//删除应付账号
	Delwf:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Delwf, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	delqgaccount:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.delqgaccount, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	saveqgaccount:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.saveqgaccount, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	delbaojialist:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.delbaojialist, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveFlightMain:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveFlightMain, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveFlightList:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveFlightList, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveSchemeList:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveSchemeList, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveSchemeMain:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveSchemeMain, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	submitqg:(param) => {
		debugger
		return new Promise((resolve, reject) => {
			$httpform($api.post.submitqg, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	CreateCopyContent:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CreateCopyContent, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SyncCargoimg:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SyncCargoimg, {
					data:{
						domain: API.WebServer,
						cargotype:param.cargotype
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveNoticeMsg:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveNoticeMsg, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveCwBill:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCwBill, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	AddStorageIn:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.AddStorageIn, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	CheckOrderWeight:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CheckOrderWeight, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	CheckOrderPayState:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CheckOrderPayState, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//创建第三方支付账单
	CreatePayOrder:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CreatePayOrder, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	OrderPay:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.OrderPay, {
					data:{
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	WxChatGetsignature:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.WxChatGetsignature, {
					data:{
						userid:param.userid,
						token:param.token
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	WxChatSendMsg:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.WxChatSendMsg, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						token:param.token
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	ThreadPrint:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.ThreadPrint, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					//timeout:30*1000,//设置超时
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveDataTemptoExcelTemp:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveDataTemptoExcelTemp, {
					data: {
						domain: API.WebServer,
						batch:param.batch
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveInput:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveInput, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SubWl:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SubWl, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveCrmExtend:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveCrmExtend, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SaveInvoice:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveInvoice, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	DownSysOrder:(param) => {
		return new Promise((resolve, reject) => {
			$httpfile($api.post.DownSysOrder, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	CreateStockserialnumber: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CreateStockserialnumber, {
					data: {
						domain: API.WebServer,
						handleraccount: localStorage.getItem('u_account'),
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	SavePrintset: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SavePrintset, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	RollBackStockBill: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.RollBackStockBill, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//删除盘点记录
	Deltacking: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Deltacking, {
					data: {
						domain: API.WebServer,
						handleraccount: localStorage.getItem('u_account'),
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//订单退款
	RefundOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.RefundOrder, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//回收站删除订单
	Deltrashorder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Deltrashorder, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//订单转换表
	ChangeOrderState: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.ChangeOrderState, {
					data: {
						domain: API.WebServer,
						p_pkval:param.p_pkval,
						batch:param.batch,
						targetstate:param.targetstate
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//分配货架
	SetCargoShelves: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetCargoShelves, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	DelStockPlan: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelStockPlan, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	UpdateStock: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateStock, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	Resolvepkval: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Resolvepkval, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	DownFile: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DownFile, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	CreateClearXml: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CreateClearXml, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	Translationorder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Translationorder, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	Verifyid: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Verifyid, {
					data: {
						domain: API.WebServer,
						handleraccount: localStorage.getItem('u_account'),
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	Setemailtemp: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Setemailtemp, {
					data: {
						domain: API.WebServer,
						handleraccount: localStorage.getItem('u_account'),
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除平台信息
	DelDsInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelDsInfo, {
					data: {
						domain: API.WebServer,
						handleraccount: localStorage.getItem('u_account'),
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存平台信息
	SaveDsInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveDsInfo, {
					data: {
						domain: API.WebServer,
						handleraccount: localStorage.getItem('u_account'),
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	ImportOrderPush: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.ImportOrderPush, {
					data: {
						domain: API.WebServer,
						p_batch: param.p_batch
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//打印面单
	OrderPrint: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.OrderPrint, {
					data: {
						domain: API.WebServer,
						paraminfo: param.paraminfo
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	registerAccount: (param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.post.registerAccount, {
					data: {
						domain:API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	login: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.login, {
				data: {
					domain:API.WebServer,
					account:encodeURIComponent(param.account),
					password:param.password
				},
				methods: "POST",
			}).then((res) => {
				resolve(res.data);
			});
		});
	},
	checklogin: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.checkBytoken, {
				data: {
					domain: API.WebServer,
					id: localStorage.getItem('token'),
				},
				methods: "POST",
			}).then((res) => {
				resolve(res.data);
			});
		});
	},
	//保存分组信息
	SaveGroup: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveGroup, {
				data: {
					domain: API.WebServer,
					groupinfo: encodeURIComponent(JSON.stringify(param.groupinfo)),
					handleraccount: localStorage.getItem('u_account')
				},
				methods: "POST",
			}).then((res) => {
				resolve(res.data);
			});
		});
	},
	//删除分组信息
	DelGroup: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelGroup, {
				data: {
					domain: API.WebServer,
					s_name: encodeURIComponent(param.s_name),
					handleraccount: localStorage.getItem('u_account')
				},
				methods: "POST",
			}).then((res) => {
				resolve(res.data);
			});
		});
	},
	//保存用户信息
	SaveUserInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveUserInfo, {
				data: {
					domain: API.WebServer,
					userinfo: encodeURIComponent(param.userinfo),
					handleraccount: localStorage.getItem('u_account')
				},
				methods: "POST",
			}).then((res) => {
				resolve(res.data);
			});
		});
	},
	//设置用户等级
	SaveUserRank: (param) => {
		console.log('设置级别参数', param);
		return new Promise((resolve, reject) => {
			$http($api.post.SaveUserRank, {
				data: {
					domain: API.WebServer,
					u_account: encodeURIComponent(param.u_account),
					handleraccount: localStorage.getItem('u_account'),
					isadmin: param.isadmin,
					rank: param.rank,
					groupname: encodeURIComponent(param.groupname)
				},
				methods: "POST",
			}).then((res) => {
				resolve(res.data);
			});
		});
	},
	//删除用户
	DelUser: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelUser, {
				data: {
					domain: API.WebServer,
					userid: encodeURIComponent(param.userid),
					handleraccount: localStorage.getItem('u_account')
				},
				methods: "POST",
			}).then((res) => {
				resolve(res.data);
			});
		});
	},
	//保存角色信息
	SaveRoleInfo: (param) => {
		//console.log('权限编号', encodeURIComponent(param.permessionid));
		return new Promise((resolve, reject) => {
			$http($api.post.SaveRoleInfo, {
					data: {
						domain: API.WebServer,
						permessionid: encodeURIComponent(param.permessionid),
						isedit: param.isedit,
						rolename: encodeURIComponent(param.rolename),
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除角色
	DelRole: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelRole, {
					data: {
						domain: API.WebServer,
						rolename: encodeURIComponent(param.rolename),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存订单
	SaveOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveOrder, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	//设置用户角色(角色管理增减人员)
	SetUserRole: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetUserRole, {
					data: {
						domain: API.WebServer,
						u_account: encodeURIComponent(param.u_account),
						rolename: encodeURIComponent(param.rolename),
						isadd: param.isadd,
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//订单放入回收站/从回收站中恢复
	SetOrderToTrash: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetOrderToTrash, {
					data: {
						domain: API.WebServer,
						l_mode: encodeURIComponent(param.l_mode),
						batch: param.batch,
						pkval: encodeURIComponent(param.pkval),
						type: param.type, //操作方式 1--放入回收站 0--从回收站中恢复
						handleraccount: localStorage.getItem('u_account'),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//将勾选数据放入临时表并返回批次号
	InsertTemp: (param) => {
		//console.log('获取临时表数据', JSON.stringify(param));
		return new Promise((resolve, reject) => {
			$http($api.post.InsertTemp, {
					data: {
						domain: API.WebServer,
						l_mode: encodeURIComponent(param.l_mode),
						tab: encodeURIComponent(param.tab),
						search: encodeURIComponent(param.search),
						sort: encodeURIComponent(param.sort),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//将勾选数据放入临时表并返回批次号
	InsertTempBysearch: (param) => {
		//console.log('获取临时表数据', JSON.stringify(param));
		return new Promise((resolve, reject) => {
			$http($api.post.InsertTempBysearch, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存订单寄件类型
	SetSendType: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetSendType, {
					data: {
						domain: API.WebServer,
						sendertype: encodeURIComponent(param.sendertype),
						batch: param.batch,
						p_batch: param.p_batch,
						pkval: param.pkval,
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存导入包裹信息
	SaveInport: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveInport, {
					data: {
						domain: API.WebServer,
						inportinfo: encodeURIComponent(param.inportinfo)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存导入包裹信息
	RollBack_Order: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.RollBack_Order, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						p_batch: encodeURIComponent(param.p_batch),
						batch: encodeURIComponent(param.batch),
						isdeltemp: param.isdeltemp
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//解析地址
	ThreadResolve: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.ThreadResolve, {
					data: {
						domain: API.WebServer,
						p_batch: encodeURIComponent(param.p_batch),
						batch:encodeURIComponent(param.batch)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//收件地址解析
	ThreadResolve_cg: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.ThreadResolve_cg, {
					data: {
						domain: API.WebServer,
						p_batch: encodeURIComponent(param.p_batch),
						batch:encodeURIComponent(param.batch)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	
	//删除订单
	DeleteOrder: (param) => {
		console.log('删除参数', JSON.stringify(param));
		return new Promise((resolve, reject) => {
			$http($api.post.DeleteOrder, {
					data: {
						domain: API.WebServer,
						batch: encodeURIComponent(param.batch),
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//出入库回滚
	RollbackStorage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.RollbackStorage, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存出入库记录
	SaveOrdertoStorage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveOrdertoStorage, {
					data: {
						domain: API.WebServer,
						isin: param.isin, //1-入库 0-出库
						handbatch: encodeURIComponent(param.handbatch), //操作批次号
						pkvals: encodeURIComponent(param.pkvals), //订单号
						weight: param.weight, //称重重量
						isprint: param.isprint, //是否打印 1-打印 0-不打印
						iscargo: param.iscargo, //是否验商品 1-验商品 0-不验商品
						ischeckpmode: param.ischeckpmode, //是否验证匹配渠道 
						p_mode: encodeURIComponent(param.p_mode), //渠道
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account'),
						u_company: localStorage.getItem('u_company'),
						u_name: localStorage.getItem('u_name')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//生成物流
	CreateStep: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CreateStep, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						batch: encodeURIComponent(param.batch),
						fun: encodeURIComponent(param.fun),
						context: encodeURIComponent(param.context),
						createtime: param.createtime
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除出入库记录
	DelStorageOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelStorageOrder, {
					data: {
						domain: API.WebServer,
						isin: encodeURIComponent(param.isin),
						pkval: encodeURIComponent(param.pkval),
						batch: encodeURIComponent(param.batch),
						handleraccount: localStorage.getItem('u_account'),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置出入库渠道启用/停用
	SetClearisEnabled: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetClearisEnabled, {
					data: {
						domain: API.WebServer,
						p_mode: encodeURIComponent(param.p_mode),
						isenabled: param.isenabled,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存出库参数设置
	SaveStorageOutParam: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveStorageOutParam, {
					data: {
						domain: API.WebServer,
						p_mode: encodeURIComponent(param.p_mode),
						paramlist: encodeURIComponent(param.paramlist),
						rulelist: encodeURIComponent(param.rulelist),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除地址库
	DeleteAddr: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DeleteAddr, {
					data: {
						domain: API.WebServer,
						addrid: param.addrid,
						type: param.type
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置/取消默认寄件地址
	SetDefaultCtAddr: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetDefaultCtAddr, {
					data: {
						domain: API.WebServer,
						addrid: param.addrid,
						isdefault: param.isdefault,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//发送消息提醒
	SendMessage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SendMessage, {
					data: {
						domain: API.WebServer,
						fun: param.fun, //功能模块
						message: encodeURIComponent(JSON.stringify(param.message)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新打印模板
	UpdateEcode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateEcode, {
					data: {
						domain: API.WebServer,
						paraminfo: param.paraminfo,
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	CheckPmodetoPrint: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CheckPmodetoPrint, {
					data: {
						domain: API.WebServer,
						handlerparam: param.handlerparam,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	SavelogisticsOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SavelogisticsOrder, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//检测输入的单号
	CheckPasteOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CheckPasteOrder, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//批量预览
	PrintPerView: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.PrintPerView, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置会员对应的财务方案
	SetViptocw: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetViptocw, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除会员方案
	Delscheme: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Delscheme, {
					data: {
						domain: API.WebServer,
						c_id: param.c_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存财务方案
	Savescheme: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Savescheme, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//会员充值
	VipCharge: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.VipCharge, {
					data: {
						domain: API.WebServer,
						payparam: encodeURIComponent(JSON.stringify(param.payparam))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存会员卡充值信息
	SaveVipCharge: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveVipCharge, {
					data: {
						domain: API.WebServer,
						payparam: encodeURIComponent(JSON.stringify(param.payparam))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//重置密码
	SavePwd: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SavePwd, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//会员卡金额转移
	SaveVipCharge_Move: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveVipCharge_Move, {
					data: {
						domain: API.WebServer,
						payparam: encodeURIComponent(JSON.stringify(param.payparam))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存批量订单
	SaveOrder_Batch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveOrder_Batch, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//批量下单（不是导入的批量，是一个界面上同时下多个不同尺寸的包裹，收寄件人信息相同)
	BatchCreateMd: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.BatchCreateMd, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存多件下单信息
	SaveOrder_More: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveOrder_More, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//多件下单（不是导入的批量，是一个界面上同时下多个不同尺寸的包裹，收寄件人信息相同，调一次下单接口下单)
	CreateMd_More: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CreateMd_More, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存包裹订单信息
	SavePackageInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SavePackageInfo, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//确认收费
	SurePayOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SurePayOrder, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//取消收费
	CancelPayOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CancelPayOrder, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除计算收费临时数据
	DelPayOrderTemp: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelPayOrderTemp, {
					data: {
						domain: API.WebServer,
						batch: param.batch
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//出入库保存操作
	StorageInOutHandle: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.StorageInOutHandle, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新批次号
	UpdateOutBatch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateOutBatch, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存用户参数
	SaveUserParam: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveUserParam, {
					data: {
						domain: API.WebServer,
						value: encodeURIComponent(param.value),
						showname: encodeURIComponent(param.showname),
						isvalue: encodeURIComponent(param.isvalue),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新重量
	UpdateWeight: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateWeight, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//订单拦截
	OrderIntercept: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.OrderIntercept, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//订单取消拦截
	Cancelintercept: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.CancelIntercept, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//转移人员分组
	MoveUser: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.MoveUser, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存客服管理新增问题
	SaveWork: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveWork, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存客服回复信息
	SaveWorkContext: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveWorkContext, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除基础资料
	DelBaseInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelBaseInfo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存基础资料
	SaveBaseInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveBaseInfo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存记账单
	SaveFeeBook: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveFeeBook, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除记账单
	DelFeeBook: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelFeeBook, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置提成比例
	UpdatePerCent: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdatePerCent, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置订单完结
	SetOrderEnd: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SetOrderEnd, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存客户信息
	SaveCustomer: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCustomer, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除客户信息
	DelCustomer: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelCustomer, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存客户跟进记录
	SaveCustomerFollow: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCustomerFollow, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新用户所属门店
	UpdateUserShopname: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateUserShopname, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存物流订单（鑫诺达)
	SavelogisticsOrder_xnd: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SavelogisticsOrder_xnd, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新重量（鑫诺达)
	UpdateWeight_xnd: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateWeight_xnd, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						weight: encodeURIComponent(param.weight),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除收付款记录
	DelCollectPay: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelCollectPay, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(param.paraminfo),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存收付款记录
	SaveCollectPay: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCollectPay, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(param.paraminfo),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除商品库资料
	DelBaseCargo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelBaseCargo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存商品库基础资料
	SaveBaseCargoInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveBaseCargoInfo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除入库单
	DelStockIn: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelStockIn, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除入库计划单
	DelStockInPlan: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelStockInPlan, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//一件代发删除
	DelStockOut_Plan: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelStockOut_Plan, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//计划单确认出库
	SureStockOut: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SureStockOut, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	//合并文件
	MergePdf: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.MergePdf, {
					data: {
						domain: API.WebServer,
						diskpath: param.diskpath
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存打印模板内容
	SavePrintTemplate: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SavePrintTemplate, {
					data: {
						domain: API.WebServer,
						t_id: param.t_id,
						template:encodeURIComponent(param.template),
						image: encodeURIComponent(param.image)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新列表上的指定表指定字段值
	UpdateGridCol: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.UpdateGridCol, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//批量更新
	BatchUpdate: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.BatchUpdate, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//订单预报
	Saveyubao: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.Saveyubao, {
					data: {
						domain: API.WebServer,
						expressid: encodeURIComponent(param.expressid),
						userid: param.userid
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存微信提醒模板设置
	SaveRemindSet: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveRemindSet, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo))),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存微信固定接收人
	SaveWxReceiver: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveWxReceiver, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo))),
						isadd: param.isadd
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//揽收扫描单号之后的操作
	HandleHarvestPage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.HandleHarvestPage, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo)))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除揽收记录
	DelStorageHarvest: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelStorageHarvest, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo))),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除上架记录
	DelStorageShelves: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelStorageShelves, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo))),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存货架
	SaveStorageShelves: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveStorageShelves, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo)))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存增值服务
	SaveOrderService: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveOrderService, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo)))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//增值服务全部已处理
	SaveOrderService_All: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveOrderService_All, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo))),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//操作问题件
	HandleWtjPage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.HandleWtjPage, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify((param.paraminfo))),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//发送提醒消息
	SendMsg: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SendMsg, {
					data: {
						domain: API.WebServer,
						template: param.template,
						xcxtemplate: param.xcxtemplate,
						recevier: param.recevier,
						msgid: param.msgid
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存拍照图片
	SavePhoto: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SavePhoto, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除照片
	DelPhoto: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.DelPhoto, {
					data: {
						domain: API.WebServer,
						filename: encodeURIComponent(param.filename),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存信息，与导入功能结合使用的，什么功能可以新增，什么信息就组合成导入信息
	SaveInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveInfo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent((JSON.stringify(param.paraminfo))),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//去打印/预览(新方法)
	GoOrderPrint: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.GoOrderPrint, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(param.paraminfo),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存寄件地址
	SaveaddressCt:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveaddressCt, {
					data: {
						domain: API.WebServer,
						addressinfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存收件地址
	SaveaddressCg:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SaveaddressCg, {
					data: {
						domain: API.WebServer,
						addressinfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetImportFee:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.GetImportFee, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(param.paraminfo)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetOrderFeeList:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.GetOrderFeeList, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(param.paraminfo)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除商品图片
	DelBaseCargoPic:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.DelBaseCargoPic, {
					data: {
						domain: API.WebServer,
						id:param.id,
						type:param.type,
						cargotype:param.cargotype
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存承诺书内容
	SaveCNS:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCNS, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.wordinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置商品开放属性
	SetCargoPublic:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SetCargoPublic, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存商品分类
	SaveCargoSort_SC:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCargoSort_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存商品品牌
	SaveCargoBrand_SC:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCargoBrand_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除分类 
	DelCargoSort_SC:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.DelCargoSort_SC, {
					data: {
						domain: API.WebServer,
						p_no:encodeURIComponent(param.p_no),
						lang:param.lang,
						cargotype:param.cargotype,
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除商品品牌
	DelCargoBrand_SC:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.DelCargoBrand_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存商品规格
	SaveSpec_SC:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SaveSpec_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除商品规格
	DelSpce_SC:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.DelSpce_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//分类绑定
	BindSort:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.BindSort, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//商城商品发布
	SaveCargo_SC:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SaveCargo_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存商品主图/轮播图
	SaveCargoPic:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveCargoPic, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						cargo_id:encodeURIComponent(param.cargo_id)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					//debugger
					reject(err);
				});
		});
	},
	//保存商品描述
	SaveCargoDescribe:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveCargoDescribe, {
					data: {
						domain: API.WebServer,
						describe:encodeURIComponent(param.describe),
						cargotype:param.cargotype,
						cargo_id:encodeURIComponent(param.cargo_id)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置商品分类启用/停用
	SetCargoSortenabled:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SetCargoSortenabled, {
					data: {
						domain: API.WebServer,
						p_no:encodeURIComponent(param.p_no),
						lang:param.lang,
						type:param.type,
						handleraccount:localStorage.getItem('u_account'),
						cargotype:param.cargotype
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置商品品牌启用/停用
	SetCargoBrandenabled:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SetCargoBrandenabled, {
					data: {
						domain: API.WebServer,
						id:encodeURIComponent(param.id),
						type:param.type,
						cargotype:param.cargotype,
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//设置商品启用/停用
	SetCargoenabled:(param) =>{
		return new Promise((resolve, reject) => {
			$http($api.post.SetCargoenabled, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存商城首页设置
	SaveIndexCargo:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveIndexCargo, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新打印状态
	UpdatePrintState:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.UpdatePrintState, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//清空快递信息
	ClearExpress:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.ClearExpress, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存税率方案
	Savetaxscheme:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.Savetaxscheme, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除税率方案
	Deltaxscheme:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.Deltaxscheme, {
					data: {
						domain: API.WebServer,
						c_id:param.c_id,
						handleraccount:localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存商品与税率方案的对应关系
	SaveCargotoTaxscheme:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveCargotoTaxscheme, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//删除物流步骤模板
	DelWlStep:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.DelWlStep, {
					data: {
						domain: API.WebServer,
						userid:localStorage.getItem('userid'),
						modename:encodeURIComponent(param.modename)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//保存物流步骤模板
	SaveWlStep:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.SaveWlStep, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//生成订单物流步骤
	CreateOrderStep:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.CreateOrderStep, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//推送订单物流
	PushOrderWl:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.PushOrderWl, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//导入订单后推送物流
	ImportOrderPush:(param) =>{
		return new Promise((resolve, reject) => {
			$httpfile($api.post.ImportOrderPush, {
					data: {
						domain: API.WebServer,
						p_batch:param.p_batch
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//发送提醒消息
	SendEmailMsg: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.SendEmailMsg, {
					data: {
						domain: API.WebServer,
						template:param.template,
						title: param.title,
						recevier: param.recevier,
						msgid: param.msgid,
						IsBodyHtml:param.ishtml
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
let get = {
	//获取导出筛选条件
	GetFeelistTemp:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetFeelistTemp, {
					data:{
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//获取导出筛选条件
	GetExportSet:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetExportSet, {
					data:{
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	GetCustomerItem:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCustomerItem, {
					data:{
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	//读取支付状态
	GetPayState:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPayState, {
					data:{
						paraminfo: encodeURIComponent(param.paraminfo)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	CheckOrder:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CheckOrder, {
					data:{
						domain: API.WebServer,
						pkval:encodeURIComponent(param.pkval),
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	GetSupplierCargoPrice:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetSupplierCargoPrice, {
					data:{
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
			});
		});
	},
	GetqgList:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetqgList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getbaojialist:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.getbaojialist, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetFlightList:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetFlightList, {
					data: {
						domain: API.WebServer,
						f_id:param.f_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetFlightMain:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetFlightMain, {
					data: {
						domain: API.WebServer,
						c_id:param.c_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetSchemeMain:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetSchemeMain, {
					data: {
						domain: API.WebServer,
						c_id:param.c_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetSchemeList:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetSchemeList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	Getqgresult:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$httpform($api.get.Getqgresult, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetLoginParam:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetLoginParam, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	CreateErrorFile:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.CreateErrorFile, {
					data: {
						domain: API.WebServer,
						batch:param.batch //,//  encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetBwList:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetBwList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetQgCompanyList:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetQgCompanyList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetArea:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetArea, {
					data: {
						domain: API.WebServer,
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetNoticeMsg:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetNoticeMsg, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetBaojiaNo:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetBaojiaNo, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetOrderInfoByLid:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderInfoByLid, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetOrderWeight:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderWeight, {
					data: {
						domain: API.WebServer,
						pkval:encodeURIComponent(param.pkval)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	CreateGrid:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.CreateGrid, {
					data: {
						domain: API.WebServer,
						pageindex:param.pageindex,
						pagesize:param.pagesize,
						sort:encodeURIComponent(param.sort),
						l_mode:encodeURIComponent(param.l_mode),
						tab:encodeURIComponent(param.tab),
						showcol:encodeURIComponent(param.showcol),
						search:encodeURIComponent(param.search),
						listparam:encodeURIComponent(param.listparam),
						iscount:param.iscount,
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	AnalysisSearch:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.AnalysisSearch, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetLanguageByMode:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetLanguageByMode, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetFilterSet:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetFilterSet, {
					data: {
						domain: API.WebServer,
						l_id:param.l_id,
						type:encodeURIComponent(param.type),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetButtons:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetButtons, {
					data: {
						domain: API.WebServer,
						l_id:param.l_id,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetTabs_Only:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetTabs_Only, {
					data: {
						domain: API.WebServer,
						l_id:param.l_id,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	CheckOrderHandleState:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.CheckOrderHandleState, {
					data: {
						domain: API.WebServer,
						batch:param.batch,
						allcount:param.allcount
					},
					timeout:20*1000,//设置超时
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetWlcode:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetWlcode, {
					data: {
						domain: API.WebServer,
						type:encodeURIComponent(param.type)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetOrderMd:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderMd, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	OpenInvoice:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.OpenInvoice, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(param.paraminfo)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetCompany:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetCompany, {
					data: {
						domain: API.WebServer,
						keyword:encodeURIComponent(param.keyword)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetUserPrintset:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.GetUserPrintset, {
					data: {
						domain: API.WebServer,
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	CheckOrderPmodeIsMul:(param) => {
		//debugger
		return new Promise((resolve, reject) => {
			$http($api.get.CheckOrderPmodeIsMul, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.handlerparam))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetPrintModeList:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPrintModeList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetCargoshelves:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCargoshelves, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetPagecolGroup:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPagecolGroup, {
					data: {
						domain: API.WebServer,
						l_mode:encodeURIComponent(param.l_mode)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetStockCargoInOutList_SumCount:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStockCargoInOutList_SumCount, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetStocktaking:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStocktaking, {
					data: {
						domain: API.WebServer,
						billid:encodeURIComponent(param.billid)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取待盘点商品信息
	GetStocktakingCargo:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStocktakingCargo, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetStockCargoWarning:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStockCargoWarning, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetStockCargoReport:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStockCargoReport, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetOrderInfoByCountry:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderInfoByCountry, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据客户账号获取绑定的客户资料唯一id
	GetCrmidByBandUaccount:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCrmidByBandUaccount, {
					data: {
						domain: API.WebServer,
						uaccount:encodeURIComponent(param.uaccount)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	CheckStockNum:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CheckStockNum, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取平台信息新增项配置
	GetDsFormat:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetDsFormat, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	///获取仓库单据详情
	GetStock:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStock, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetOrderTabCount:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderTabCount, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						l_mode:encodeURIComponent(param.l_mode),
						tab: encodeURIComponent(param.tab),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetUserDsList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetUserDsList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取邮件接收人
	GetEmailRecevier: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetEmailRecevier, {
					data: {
						domain: API.WebServer,
						pkval:param.pkval,
						type: param.type,
						msgid: param.msgid,
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetDsInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetDsInfo, {
					data: {
						domain: API.WebServer,
						id:param.id
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取验证码图片
	getyzmimg: () => {
		return new Promise((resolve, reject) => {
			$http($api.get.getyzmimg, {
					data: {

					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取基本信息
	sysinfo: () => {
		return new Promise((resolve, reject) => {
			$http($api.get.sysinfo, {
					data: {
						domain: API.WebServer,
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getLeftMenu: () => {
		return new Promise((resolve, reject) => {
			$http($api.get.getLeftMenu, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem("userid"),
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	dic: (param) => {
		if(param.value==undefined)
			param.value='';
		return new Promise((resolve, reject) => {
			$http($api.get.dic, {
					data: {
						domain: API.WebServer,
						type: encodeURIComponent(param.type),
						value:encodeURIComponent(param.value)
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getTheme: () => {
		return new Promise((resolve, reject) => {
			if (localStorage.getItem('theme') == null || localStorage.getItem('theme') == '') {
				$http($api.get.gettheme, {
						data: {
							domain: API.WebServer,
							sysname: encodeURIComponent("出口系统"),
							userid: localStorage.getItem("userid")
						},
						methods: 'post'
					})
					.then((res) => {
						//console.log('主题', res);
						if (res.data.state == 1) {
							resolve(res.data.theme);
							localStorage.setItem('theme', res.data.theme);
						}
					})
					.catch((err) => {
						reject(err);
					});
			} else {
				resolve(localStorage.getItem('theme'));
			}
		});
	},
	//获取角色列表
	GetRoleList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetRoleList, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem("userid"),
						search: encodeURIComponent(param.search)
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取角色列表，用于下拉选项
	GetRoleOption: () => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetRoleOption, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem("userid"),
						search: ''
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取计费方案，用于下拉选项
	GetPayruleOption: () => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPayruleOption, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem("userid")
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取门店列表
	Getshop: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.Getshop, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取所有门店，注册时使用
	GetGroup: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetGroup, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(JSON.stringify(param.search)),
						isshop: param.isshop,
						userid: param.userid
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取系统参数
	GetSystemParam: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetSystemParam, {
					data: {
						domain: API.WebServer,
						showname: encodeURIComponent(param.showname),
						type: param.type //1--参数值类型 2--开启关闭类型
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取提醒设置信息
	GetRemindSet: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetRemindSet, {
					data: {
						domain: API.WebServer,
						permessionid: param.permessionid,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取用户列表
	GetUserlist: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetUserList, {
					data: {
						domain: API.WebServer,
						pageindex: param.pageindex,
						pagesize: param.pagesize,
						search: encodeURIComponent(param.search),
						sort: encodeURIComponent(param.sort),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					if (res.data != '') {
						resolve(res.data);
					}
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取列配置
	GetColumns: (param) => {
		return new Promise((resolve, reject) => {
			if(param.sys==undefined)
				param.sys='';
			if(param.checkfield==undefined)
				param.checkfield='1';
			$http($api.get.GetColumns, {
					data: {
						domain: API.WebServer,
						tab: encodeURIComponent(param.tab),
						userid: localStorage.getItem('userid'),
						checkfield: param.checkfield,
						parentid: param.parentid,
						mode: encodeURIComponent(param.mode),
						sys:encodeURIComponent(param.sys)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取用户操作权限
	GetUserPermession: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetUserPermession, {
					data: {
						domain: API.WebServer,
						mode: encodeURIComponent(param.mode),
						type: param.type,
						parentid: param.parentid,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取权限功能数组
	GetPermession: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.post.GetPermession, {
					data: {
						domain: API.WebServer,
						rolename: encodeURIComponent(param.rolename),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取布局信息
	CreatePageLayout: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CreatePageLayout, {
					data: {
						domain: API.WebServer,
						sys: encodeURIComponent(param.sys),
						fun: encodeURIComponent(param.fun)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据口岸获取布局信息
	CreatePageLayoutByPmode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CreatePageLayoutByPmode, {
					data: {
						domain: API.WebServer,
						sys: encodeURIComponent(param.sys),
						fun: encodeURIComponent(param.fun),
						type: encodeURIComponent(param.type),
						p_mode: encodeURIComponent(param.p_mode),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取权限内的渠道
	GetClarance: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetClarance, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取门店列表
	GetShopList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetShopList, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取选项卡
	GetTabs: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetTabs, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid'),
						parentid: param.parentid
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取订单信息
	GetOrderInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderInfo, {
					data: {
						domain: API.WebServer,
						pkval: param.pkval
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取包裹列表信息
	//string domain, string search, string tab, int pageindex, int pagesize, string sort, string showcol, string userid
	GetPackageList: (param) => {
		return new Promise((resolve, reject) => {
			//console.log('列表参数',JSON.stringify(param));
			if(param.iscount==undefined)
				param.iscount=0;
			$http($api.get.GetPackageList, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						tab: encodeURIComponent(param.tab),
						pageindex: param.pageindex,
						pagesize: param.pagesize,
						sort: encodeURIComponent(param.sort),
						showcol: encodeURIComponent(param.showcol),
						l_mode:encodeURIComponent(param.l_mode),
						userid: localStorage.getItem('userid'),
						iscount:param.iscount
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取包裹信息汇总数
	GetPackageCount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPackageCount, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						tab: encodeURIComponent(param.tab),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取物流管理汇总数
	GetLogisticsCount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetLogisticsCount, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						tab: encodeURIComponent(param.tab),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取列表数据
	GetGridData: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetGridData, {
					data: {
						domain: API.WebServer,
						l_mode: encodeURIComponent(param.l_mode), //所属功能模块 ，可为空
						tab: encodeURIComponent(param.tab), //选项卡名 ，可为空
						showcol: encodeURIComponent(param.showcol), //显示的列配置json数组
						pageindex: param.pageindex, //分页索引
						pagesize: param.pagesize, //每页显示数
						sort: encodeURIComponent(param.sort), //排序字段以及排序方式
						search: encodeURIComponent(param.search), //筛选条件
						listparam: encodeURIComponent(param.listparam), //附加参数,可为空
						tablename: param.tablename, //查询的业务表名或者存储过程名
						iscount: param.iscount, //是否汇总条数
						userid: param.userid //查询的用户id
					},
					methods: 'post'
				})
				.then((res) => {
					console.log('加载列表成功', res);
					resolve(res.data);
				})
				.catch((err) => {
					console.log('加载列表失败', err);
					reject(err);
				});
		});
	},
	//获取常用筛选条件
	GetFilter: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetFilter, {
					data: {
						domain: API.WebServer,
						l_mode: encodeURIComponent(param.l_mode),
						type: encodeURIComponent(param.type)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//匹配商品库
	MatchOrderCargo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.MatchOrderCargo, {
					data: {
						domain: API.WebServer,
						p_batch: encodeURIComponent(param.p_batch),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//导出未匹配成功的商品
	ExportNomatchCargo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.ExportNomatchCargo, {
					data: {
						domain: API.WebServer,
						batch: encodeURIComponent(param.batch)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//计算税金
	Calculatetaxfee: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.Calculatetaxfee, {
					data: {
						domain: API.WebServer,
						batch: encodeURIComponent(param.batch)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//计算税金
	ExportErrorOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.ExportErrorOrder, {
					data: {
						domain: API.WebServer,
						p_batch: encodeURIComponent(param.p_batch)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//验证订单的渠道
	CheckPmodetoPrint: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CheckPmodetoPrint, {
					data: {
						domain: API.WebServer,
						handlerparam: encodeURIComponent(param.handlerparam),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取打印模板
	GetPrintBzMode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPrintBzMode, {
					data: {
						domain: API.WebServer,
						pmode: encodeURIComponent(param.p_mode),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//组合临时表中单号
	GetTempBatch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetTempBatch, {
					data: {
						domain: API.WebServer,
						batch: param.batch
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取物流
	getwl: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.getwl, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取航空信息
	GetAirway: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetAirway, {
					data: {
						domain: API.WebServer,
						airwaybill: encodeURIComponent(param.airwaybill)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//查询国内物流信息
	Getwaybill_GN: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.Getwaybill_GN, {
					data: {
						domain: API.WebServer,
						expressid: encodeURIComponent(param.expressid),
						expresscode: encodeURIComponent(param.expresscode)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//回收站列表
	GetHszList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetHszList, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						pageindex: param.pageindex,
						pagesize: param.pagesize,
						sort: encodeURIComponent(param.sort),
						showcol: encodeURIComponent(param.showcol),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//检测并获取订单信息
	CheckandGetorder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CheckandGetorder, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						subpkval: encodeURIComponent(param.subpkval),
						batch: encodeURIComponent(param.batch),
						outbatch: encodeURIComponent(param.outbatch),
						isfee: encodeURIComponent(param.isfee),
						p_mode: encodeURIComponent(param.p_mode),
						isbyin: param.isbyin,
						isin: param.isin,
						isunpack: param.isunpack,
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取进出口的渠道
	GetStorageClearance: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStorageClearance, {
					data: {
						domain: API.WebServer,
						isenabled: param.isenabled, //是否启用, 0--未启用 1-启用 传入空则表示查询全部
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取已授权的渠道
	GetStoragePmode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStoragePmode, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取出入库打单参数
	GetInOutParam: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetInOutParam, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//计算费用
	CollectFee: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CollectFee, {
					data: {
						domain: API.WebServer,
						vipaccount: param.vipaccount,
						sort: param.sort,
						grossweight: param.grossweight,
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//出入库管理列表
	GetStorageList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStorageList, {
					data: {
						domain: API.WebServer,
						isin: param.isin,
						search: encodeURIComponent(param.search),
						tab: encodeURIComponent(param.tab),
						pageindex: param.pageindex,
						pagesize: param.pagesize,
						sort: encodeURIComponent(param.sort),
						showcol: encodeURIComponent(param.showcol),
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取出库参数
	GetStorageOutParam: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStorageOutParam, {
					data: {
						domain: API.WebServer,
						p_mode: encodeURIComponent(param.p_mode),
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取报价单
	GetRate: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetRate, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取国家信息
	GetCountry: (param) => {
		if(param.isall==undefined)
			param.isall="1";
		return new Promise((resolve, reject) => {
			$http($api.get.GetCountry, {
					data: {
						domain: API.WebServer,
						searchkey:encodeURIComponent(param.searchkey),
						isall:param.isall
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取地址库信息
	GetAddresslist: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetAddresslist, {
					data: {
						domain: API.WebServer,
						type: param.type,
						searchjson: encodeURIComponent(param.searchjson),
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取指定功能布局类型
	CreatePageLayoutType: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CreatePageLayoutType, {
					data: {
						domain: API.WebServer,
						sys: encodeURIComponent(param.sys),
						fun: encodeURIComponent(param.fun)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取默认寄件地址
	GetDefaultCtaddr: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetDefaultCtaddr, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid'),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//解析地址
	SplitAddr: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.SplitAddr, {
					data: {
						domain: API.WebServer,
						addrinfo: encodeURIComponent(param.addrinfo),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取输入提示信息，目前用于品名、品牌、材质等等输入的提示信息
	GetInputTips: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetInputTips, {
					data: {
						domain: API.WebServer,
						searchkey: encodeURIComponent(param.searchkey),
						col: encodeURIComponent(param.col)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据邮编获取基本地址信息
	GetBaseAddrByPostCode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetBaseAddrByPostCode, {
					data: {
						domain: API.WebServer,
						country: encodeURIComponent(param.country),
						postcode: encodeURIComponent(param.postcode)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//判断本机是否包含指定打印机
	checkprinter: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.checkprinter, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid'),
						localprinter: encodeURIComponent(param.localprinter),
						ecode: encodeURIComponent(param.ecode)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//更新所选订单的打印模板
	UpdateEcode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.UpdateEcode, {
					data: {
						domain: API.WebServer,
						batch: encodeURIComponent(param.batch),
						ecode: param.ecode,
						handlerparam: encodeURIComponent(param.handlerparam)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取基础地址信息
	GetBaseAddr: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetBaseAddr, {
					data: {
						domain: API.WebServer,
						searchinfo: encodeURIComponent(param.searchinfo)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetOrderList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderList, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(param.paraminfo)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
				
		});
	},
	//获取列表
	GetGridTable: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetGridTable, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取财务方案明细
	Getscheme: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.Getscheme, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取会员卡余额信息
	getvipbyvipaccount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.getvipbyvipaccount, {
					data: {
						domain: API.WebServer,
						vipaccount: param.vipaccount
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取汇率
	GetChargeRate: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetChargeRate, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取支付状态
	getpayorder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.getpayorder, {
					data: {
						domain: API.WebServer,
						payparam: encodeURIComponent(JSON.stringify(param.payparam)),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取导出模板
	GetExportTemplate: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetExportTemplate, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//生成导出模板
	OrderExport_Batch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.OrderExport_Batch, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取权限内的财务方案类型
	GetSchemeType: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetSchemeType, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//批量查询最新物流动态
	Getwl_Batch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.Getwl_Batch, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//批量获取报价
	GetOrderRate_Batch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderRate_Batch, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取会员卡明细
	VipBill: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.VipBill, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取会员卡明显汇总
	GetVipBillCount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetVipBillCount, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//批量获取报价
	GetOrderRate_More: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderRate_More, {
					data: {
						domain: API.WebServer,
						orderinfo: encodeURIComponent(JSON.stringify(param.orderinfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取分类
	GetSort: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetSort, {
					data: {
						domain: API.WebServer,
						pid: param.pid
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//订单收费状态列表
	PayOrderList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.PayOrderList, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//订单收费状态汇总
	PayOrderCount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.PayOrderCount, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//计算费用
	CulatefeeOrder: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CulatefeeOrder, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid'),
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取出入库界面参数
	LoadStoragePrintPage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.LoadStoragePrintPage, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//预估费用
	PredictFee: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.PredictFee, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取客服管理列表
	GetMyWorkList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetMyWorkList, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取包裹信息汇总数
	GetMyWorkCount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetMyWorkCount, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						l_mode: encodeURIComponent(param.l_mode),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取客服订单详情
	GetWorkContext: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetWorkContext, {
					data: {
						domain: API.WebServer,
						q_id: param.q_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//检测单号状态
	CheckOrderPkval: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CheckOrderPkval, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//下载服务单对话中的附件
	DownWorkFile: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.DownWorkFile, {
					data: {
						domain: API.WebServer,
						q_id: encodeURIComponent(param.q_id),
						id: encodeURIComponent(param.id)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取订单拦截日志
	Getkflist: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.Getkflist, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取订单操作日志
	GetHandleLog: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetHandleLog, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取基础类型
	GetBaseType: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetBaseType, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//交易账单
	VipChargePaylist: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.VipChargePaylist, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo)),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取功能模块
	GetMode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetMode, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取操作记账列表信息
	FeeBooklist: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.FeeBooklist, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取客户列表
	GetCustomer: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCustomer, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取账单详情
	GetFeeBookInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetFeeBookInfo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取客户详细信息
	GetCustomerInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCustomerInfo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取客户跟进记录
	GetCustomerFollow: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCustomerFollow, {
					data: {
						domain: API.WebServer,
						crm_c_id: encodeURIComponent(param.crm_c_id)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取客户管理列表选项卡汇总数
	GetCustomerTodealCount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCustomerTodealCount, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取客户待处理事项列表
	GetCustomerTodeal: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCustomerTodeal, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取门店人员列表
	GetSetUserlist: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetSetUserlist, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取收付款记录
	CollectPaylist: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CollectPaylist, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取收付款详情信息
	GetCollectPayInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCollectPayInfo, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//收支报表列表
	CollectPay_Report: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CollectPay_Report, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商品库管理列表
	GetBaseCargoList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetBaseCargoList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商品库基础资料
	GetBaseCargoInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetBaseCargoInfo, {
					data: {
						domain: API.WebServer,
						id: encodeURIComponent(param.id)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//仓库管理-入库/出库 列表
	GetStockInOutList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStockInOutList, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//仓库管理-库存列表
	GetStockList: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStockList, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据权限获取词典信息
	GetDicByRole: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetDicByRole, {
					data: {
						domain: API.WebServer,
						type: encodeURIComponent(param.type),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取打印模板列表
	GetPrintMode: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPrintMode, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取打印模板内容
	GetPrintTemp: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPrintTemp, {
					data: {
						domain: API.WebServer,
						t_id: param.t_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取税号
	GetTaxid: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetTaxid, {
					data: {
						domain: API.WebServer,
						cname: encodeURIComponent(param.cname)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//海淘管理列表
	GetHaitaoCount: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetHaitaoCount, {
					data: {
						domain: API.WebServer,
						search: encodeURIComponent(param.search),
						tab: encodeURIComponent(param.tab),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取功能基本信息
	GetLinkInfo: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetLinkInfo, {
					data: {
						domain: API.WebServer,
						l_id: param.l_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取用户所属门店信息
	GetShopByUser: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetShopByUser, {
					data: {
						domain: API.WebServer,
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据批次号获取所有已扫描订单
	GetOrderlistByBatch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderlistByBatch, {
					data: {
						domain: API.WebServer,
						handbatch: encodeURIComponent(param.handbatch),
						isin: param.isin
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取微信提醒设置
	RemindSet_Wx: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.RemindSet_Wx, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//生成微信临时二维码
	CreateTempEwm: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CreateTempEwm, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取微信模板固定接收人
	GetWxReceiver: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetWxReceiver, {
					data: {
						domain: API.WebServer,
						id: param.id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//读取微信模板设置信息
	GetRemindTempSet: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetRemindTempSet, {
					data: {
						domain: API.WebServer,
						id: param.id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取揽收列表
	GetStorageHarvest: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStorageHarvest, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//检测揽收件
	LoadHarvestPage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.LoadHarvestPage, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据揽收批次号获取所有揽收记录
	GetHarvestlistByBatch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetHarvestlistByBatch, {
					data: {
						domain: API.WebServer,
						handbatch: encodeURIComponent(param.handbatch)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取上架列表
	GetStorageShelves: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetStorageShelves, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据批次号和货架号获取已扫描订单
	GetShelveslistByBatch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetShelveslistByBatch, {
					data: {
						domain: API.WebServer,
						handbatch: encodeURIComponent(param.handbatch),
						shelves: encodeURIComponent(param.shelves)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取上架操作界面
	LoadShelvesPage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.LoadShelvesPage, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//检测订单是否可以新增、修改增值服务
	CheckOrderService: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CheckOrderService, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据批次号获取问题件
	GetWtjlistByBatch: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetWtjlistByBatch, {
					data: {
						domain: API.WebServer,
						handbatch: encodeURIComponent(param.handbatch)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//加载问题件界面
	LoadWtjPage: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.LoadWtjPage, {
					data: {
						domain: API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//组合消息接收人
	GetMsgRecevier: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetMsgRecevier, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						type: param.type,
						msgid: param.msgid,
						userid: localStorage.getItem('userid') //当前操作人id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//组合消息模板
	ComposeMsgTemp: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.ComposeMsgTemp, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo)),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取 开启 \关闭参数值
	GetEnabledParam: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetEnabledParam, {
					data: {
						domain: API.WebServer,
						paramname: encodeURIComponent(param.paramname),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取拍照记录
	GetPhoto: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPhoto, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//下载照片
	DownPhoto: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.DownPhoto, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						syscode:param.syscode,
						handleraccount: localStorage.getItem('u_account')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//根据渠道查找导入配置信息
	GetTransFormat: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetTransFormat, {
					data: {
						domain: API.WebServer,
						p_mode: encodeURIComponent(param.p_mode)
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取动态生成的页面配置
	GetPagecolSet: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPagecolSet, {
					data: {
						domain: API.WebServer,
						syscol: encodeURIComponent(param.syscol),
						l_mode: encodeURIComponent(param.l_mode),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取订单信息，兼容一票多件
	GetOrderInfo_More: (param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetOrderInfo_More, {
					data: {
						domain: API.WebServer,
						pkval: encodeURIComponent(param.pkval),
						userid: localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取文件base64
	ShowFile:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.ShowFile, {
					data: {
						domain: API.WebServer,
						filename:param.filename,
						syscode: param.syscode
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取接口秘钥(用于上传身份证)
	GetApiSecret:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetApiSecret, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//检测域名
	GetDomainByIp:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetDomainByIp, {
					data: {
						domain: API.WebServer
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商品分类列表
	GetCargoSortList:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCargoSortList, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商品品牌
	GetCargoBrand_SC:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCargoBrand_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取规格列表,信息
	GetSpce_SC:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetSpce_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商城商品基本信息
	GetCargoInfo_SC:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCargoInfo_SC, {
					data: {
						domain: API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商城商品主图/轮播图
	GetCargoPic:(param) => {
		if(param.isweb==undefined)
			param.isweb='';
		return new Promise((resolve, reject) => {
			$http($api.get.GetCargoPic, {
					data: {
						domain: API.WebServer,
						pkcno:encodeURIComponent(param.pkcno),
						type:param.type,
						cargotype:param.cargotype,
						isweb:param.isweb,
						lang:param.lang
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商品描述
	GetCargoDescribe:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCargoDescribe, {
					data: {
						domain: API.WebServer,
						cargo_id:encodeURIComponent(param.cargo_id),
						cargotype:param.cargotype,
						isedit:param.isedit
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商城首页设置
	GetIndexcargo:(param) => {
		if(param.lang==undefined)
			param.lang='';
		return new Promise((resolve, reject) => {
			$http($api.get.GetIndexcargo, {
					data: {
						domain: API.WebServer,
						type:param.type,
						lang:param.lang,
						cargotype:param.cargotype,
						isweb:param.isweb
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	GetPrintOrderList:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPrintOrderList, {
					data: {
						domain:API.WebServer,
						paraminfo:JSON.stringify(param.paraminfo),
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	DownMdFile:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.DownMdFile, {
					data: {
						domain:API.WebServer,
						paraminfo: encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取打印模板
	GetPrintTemplate:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetPrintTemplate, {
					data: {
						domain:API.WebServer,
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//验证扫描单号
	CheckScanOrder:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.CheckScanOrder, {
					data: {
						domain:API.WebServer,
						paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取税费方案
	Gettaxscheme:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.Gettaxscheme, {
					data: {
						domain:API.WebServer,
						c_id:param.c_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取商品分类最末级
	GetCargoSort_Last:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCargoSort_Last, {
					data: {
						domain:API.WebServer,
						searchkey:encodeURIComponent(param.searchkey),
						cargotype:param.cargotype
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取方案对应的商品编号
	GetCnoByTaxscheme:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetCnoByTaxscheme, {
					data: {
						domain:API.WebServer,
						c_id:param.c_id
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取物流步骤模板
	GetWlStep:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetWlStep, {
					data: {
						domain:API.WebServer,
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取用户店铺信息
	GetUserds:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetUserds, {
					data: {
						domain:API.WebServer,
						type:encodeURIComponent(param.type),
						userid:localStorage.getItem('userid')
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取设备参数方案
	GetParamtodevice:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetParamtodevice, {
					data: {paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	//获取所有台号
	GetDeskList:(param) => {
		return new Promise((resolve, reject) => {
			$http($api.get.GetDeskList, {
					data: {paraminfo:encodeURIComponent(JSON.stringify(param.paraminfo))
					},
					methods: 'post'
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
export default {
	get,
	post,
};
